import React from "react";
import {
  Collapse,
  ControlGroup,
  Tag,
  EditableText,
  Card,
  Elevation,
  Button,
} from "@blueprintjs/core";
import AsyncSelWrap from "../../utils/AsyncSelWrap";
import Advice from "./Advice";
import { inject, observer } from "mobx-react";
import { apiCallPost } from "../../fns/util";
import cogoToast from "cogo-toast";
import ClinicalEntity from "../templates/ClinicalEntity";
import { generateMasterVisitEntities } from "../turbo/masterVisitEntities";

class PlanAdvice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: true,
      notesText: null,
      notesTouched: false,
      searching: false,
      searchResults: [],
    };
    this.masterVisitEntities = generateMasterVisitEntities(
      this.props.authStore.prefix
    );

    let section_ = null;
    let subsection_ = null;

    for (let section of this.masterVisitEntities) {
      if (section.sectionName !== "PLAN") continue;
      for (let subsection of section.subsections) {
        if (subsection.subsectionName === "ADVICE") {
          section_ = section;
          subsection_ = subsection;
          break;
        }
      }
    }
    this.section = section_;
    this.subsection = subsection_;
  }

  renderShort = () => {
    if (!this.props.data.advise || !this.props.data.advise.length) {
      return (
        <Tag minimal large>
          No advice added.
        </Tag>
      );
    }
    let adv = this.props.data.advise.map((each) => each.text);
    let txt = adv.join(", ");
    return (
      <Tag minimal large multiline>
        {txt}
      </Tag>
    );
  };
  renderHeading = () => {
    return (
      <ControlGroup>
        <Tag
          large
          intent="primary"
          interactive
          onClick={() => this.setState({ collapse: !this.state.collapse })}
        >
          Advice
        </Tag>
        {!this.state.collapse ? (
          this.renderShort()
        ) : (
          <>
            {" "}
            <AsyncSelWrap
              placeholder="Advice..."
              searching={this.state.searching}
              items={this.state.searchResults.map((each) => {
                return {
                  ...each,
                  item: each.entityName,
                };
              })}
              selectedItem={null}
              update={(item) => this.search(item)}
              onChange={(item) => {
                this.props.onUpdate({
                  dischargeEntities: [
                    ...this.props.data.dischargeEntities,
                    { ...item, sectionName: "PLAN", subsectionName: "ADVICE" },
                  ],
                });
              }}
            />{" "}
          </>
        )}
      </ControlGroup>
    );
  };
  renderAdvice = () => {
    let advice = this.props.data.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "PLAN" &&
        currentItem.subsectionName === "ADVICE"
    );
    if (!advice || !advice.length) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No advice added.
          </Tag>
        </ControlGroup>
      );
    }
    return advice.map((each, index) => {
      return (
        <ClinicalEntity
          isShortForm={each.isShortForm}
          data={each}
          key={`${index}__${each._id}__${each.updatedAt}`}
          subsection={this.subsection}
          entity={each}
          updateVisitEntity={(item) => {
            const idx = this.props.data.dischargeEntities.findIndex(
              (each) => each._id === item._id
            );
            let obj = {
              dischargeEntities: [
                ...this.props.data.dischargeEntities.slice(0, idx),
                item,
                ...this.props.data.dischargeEntities.slice(idx + 1),
              ],
            };
            this.props.onUpdate(obj);
          }}
          removeVisitEntity={() => {
            const idx = this.props.data.dischargeEntities.findIndex(
              (de) => de._id === each._id
            );
            let obj = {
              dischargeEntities: [
                ...this.props.data.dischargeEntities.slice(0, idx),
                ...this.props.data.dischargeEntities.slice(idx + 1),
              ],
            };
            this.props.onUpdate(obj);
          }}
        />
        // <Advice
        //   data={each}
        //   update={(adviceId, key, value) => {
        //     let meds = advice;
        //     let idx = meds.findIndex((each) => each._id === adviceId);
        //     meds[idx][key] = value;
        //     this.props.onUpdate({
        //       dischargeEntities: [...this.props.data.dischargeEntities, meds],
        //     });
        //   }}
        //   remove={(adviceId) => {
        //     let meds = this.props.data.dischargeEntities;
        //     let idx = meds.findIndex((each) => each._id === adviceId);
        //     meds.splice(idx, 1);
        //     this.props.onUpdate({
        //       dischargeEntities: [...meds],
        //     });
        //   }}
        // />
      );
    });
  };
  search = async (string) => {
    if (!string) {
      this.setState({ searchResults: [] });
      return;
    }
    try {
      this.setState({ searching: true });
      let res = await apiCallPost(
        `/clinical2/${this.props.authStore.prefix}/canonical-search`,
        { entityType: "ADVICE", prefix: string }
      );
      this.setState({ searchResults: res, searching: false });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  render() {
    return (
      <Card
        style={{ padding: "0px", background: "none" }}
        elevation={Elevation.FOUR}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "start",
            justifyContent: "left",
            padding: "10px",
          }}
        >
          {this.renderHeading()}
          <Collapse isOpen={this.state.collapse}>
            {this.renderAdvice()}
          </Collapse>
        </div>
      </Card>
    );
  }
}
export default inject("authStore")(observer(PlanAdvice));
